import React from 'react';
import LaunchIcon from '@mui/icons-material/Launch';
import { TextDefault } from '@awarego-ui/components';

// `description` optionally overrides the body text. When omitted, the original
// "Learn more on how to integrate with {product}." sentence is used, so every
// existing caller (which passes only href + product) is unaffected.
function IntegrationDetailSidebar({ href, product, description }) {
    return (
        <div className="integration-detail-sidebar">
            <div className="d-flex align-items-center">
                <a href={href} target="_blank" rel="noopener noreferrer">
                    <TextDefault themed bold>
                        Online documentation{' '}
                    </TextDefault>
                    <LaunchIcon fontSize="small" color="primary" />
                </a>
            </div>
            <p>
                {description ||
                    `Learn more on how to integrate with ${product}.`}
            </p>
        </div>
    );
}

export default IntegrationDetailSidebar;
